import React from 'react'
import PublicInformationView from '../PublicInformationView'

const VerifyEmail = props => {
  const urlParams = new URLSearchParams(window.location.search)
  const status = urlParams.get('status')
  const success = ['success', 'already-rated', 'already-verified'].includes(
    status,
  )
  const title = `Email Verification  ${success ? 'Successful' : 'Error'}`
  const description = success
    ? 'Your email was successfully verified. You can now return to the app to login or continue.'
    : ' This link is no longer valid.'

  return <PublicInformationView title={title} description={description} />
}

export default VerifyEmail



// WEBPACK FOOTER //
// ./src/Components/Auth/VerifyEmail/index.js